import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@mui/material/CardActions';

export const LoadingCard = () => (
  <Card sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
    <CardHeader
      avatar={<Skeleton height={40} variant="circular" width={40} />}
      subheader={<Skeleton variant="text" width="50%" />}
      title={<Skeleton variant="text" width="70%" />}
    />
    <CardContent sx={{ flexGrow: 1 }}>
      <Typography color="textSecondary" component="p" variant="body2">
        <Skeleton width="50%" />
        <Skeleton width="80%" />
        <Skeleton width="70%" />
        <Skeleton width="60%" />
      </Typography>
    </CardContent>
    <CardActions>
      <Skeleton height={36} variant="rounded" width={124} />
    </CardActions>
  </Card>
);
